let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kb7kZ")).then(() => parcelRequire('l9iLc'));